// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2db33d0","667":"67777d2c","884":"ab2162f6"}[chunkId] + ".chunk.js";
};